import { render, staticRenderFns } from "./exit.vue?vue&type=template&id=5420115e&scoped=true&"
import script from "./exit.vue?vue&type=script&lang=js&"
export * from "./exit.vue?vue&type=script&lang=js&"
import style0 from "./exit.vue?vue&type=style&index=0&id=5420115e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5420115e",
  null
  
)

export default component.exports